import React from 'react';
import { SILOS } from '../../data/blog/silos';
import type { SiloId } from '../../types/blog';

interface SiloBadgeProps {
  silo: SiloId;
  size?: 'sm' | 'md';
}

const SiloBadge: React.FC<SiloBadgeProps> = ({ silo, size = 'sm' }) => {
  const siloData = SILOS[silo];
  const sizeClasses = size === 'md' ? 'px-3 py-1.5 text-sm' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold text-white ${siloData.color} ${sizeClasses}`}
    >
      {siloData.title}
    </span>
  );
};

export default SiloBadge;
